import { JSX } from "react";

export const ChoiceSelectionHeader = (): JSX.Element => {
    return (
        <div className={"p-choice-selection__header"}>
            <h1>
                Which <span>color</span> will be next?
            </h1>
            <p>Vote for the future of SPRSO</p>
        </div>
    );
};
